import { Title } from '@angular/platform-browser';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import moment from 'moment';
import { DatabaseService } from '@app/database/database.service';
import { ExamFormContainerService } from '@app/shared/views/exam-form-container/exam-form-container.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { AsideService } from '@app/shared/components/aside/aside.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { ExamsConfigService } from '../exams-config/exams-config.service';
import { Examen } from '../exams-config/Examen.config';
import { GroupETemplateService } from './group-e-template.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { IEspecialidades } from '@app/database/models/IEspecialidades.model';

@Component({
  selector: 'app-group-e-template',
  templateUrl: './group-e-template.component.html',
  styleUrls: ['./group-e-template.component.scss'],
})
export class GroupETemplateComponent implements OnInit, OnDestroy {
  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  @Input() examen: any;
  submitted = false;
  public examForm: FormGroup;
  fecha: any;
  seniority = 0;
  unidadTiempo = '';
  radio: any;
  maxDate = new Date();
  maxDateIngreso = new Date();
  minDate: any;
  tiposDictamen: any[] = [];
  especialidades: IEspecialidades[];
  asideObservable: Subscription;
  displayAgentes = false;
  invalidField = true;
  attachedFiles: any = {
    data: [],
    invalid: false,
    isEmpty: true,
    attachedFilesValidQuantity: 0
  };
  baseUrl = '';
  configForm: Examen;
  messageType = true;
  enviandose = false;
  isOnline = true;
  displayModalFirma = false;
	medicoFirmaB64;
  medicoFirmaSigString;
  cuadroHerniasInvalid = true;
  cuadroVaricesInvalid = true;
  columnaVertebralInvalid = true;
  enableTableVarices = false;
  enableTableHernias = false;
  cpaHasWhiteSpaces: Boolean = false;
  cpHasWhiteSpaces: Boolean = false;
  unidadesTiempoTabaquismo = [
		{ label: 'Semanas', value: 'Semanas' },
		{ label: 'Meses', value: 'Meses' },
		{ label: 'Años', value: 'Años' }
	];

  constructor(
    private titleService: Title,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageAlertServices: MessageAlertService,
    private asideService: AsideService,
    private backgroundSyncService: BackgroundSyncService,
    private databaseService: DatabaseService,
    private examConfigService: ExamsConfigService,
    private templateEService: GroupETemplateService,
    private connectionService: ConnectionService) {
  }

  get f(): any {
    return this.examForm.controls;
  }

  ngOnDestroy(): void {
    if (this.asideObservable) {
      this.asideObservable.unsubscribe();
    }
    this.asideService.setInsideExamen(false);
    this.titleService.setTitle('Provincia ART ML Offline');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Provincia ART ML Offline');

    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));

    this.cargarFormulario();
    this.calcularAntiguedad();
    this.getTiposDictamen();
    this.getEspecialidades();
    this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
    this.asideObservable = this.asideService.openModalSubject$.subscribe(
      (data) => {
        this.goBack(data);
      }
    );
    this.asideService.setInsideExamen(true);
    this.examForm.controls.peso.valueChanges.subscribe(() => this.validateAndClearIMC());
    this.examForm.controls.talla.valueChanges.subscribe(() => this.validateAndClearIMC());
  }

  validateAndClearIMC() {
    const peso = this.examForm.controls.peso.value;
    const talla = this.examForm.controls.talla.value;

    const pesoValido = peso >= 40 && peso <= 180;
    const tallaValida = talla >= 100 && talla <= 220;

    if (!pesoValido || !tallaValida) {
      this.examForm.controls.indiceMasaCorporal.setValue(null);
      this.examForm.controls.indiceMasaCorporal.markAsTouched(); // Para forzar el error visual si es required
      this.examForm.controls.indiceMasaCorporal.updateValueAndValidity();
    }
  }

  ngAfterViewInit(): void {
    this.setValuesOnFormOnVerOrEditMode();
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    this.validateCheckboxItems();
    this.validateCuadroVarices();
    this.validateCuadroHernias();
    this.validateSeccionColumna();
    this.validateSeccionOjos();
    this.validateCP();
    if (this.examForm.invalid || this.invalidField || this.cuadroHerniasInvalid || this.cuadroVaricesInvalid
      || this.columnaVertebralInvalid || this.attachedFiles.invalid || this.cpaHasWhiteSpaces || this.medicoFirmaB64 == null) {
      this.navigateInvalidField('ng-invalid');
      return;
    }
    this.enviandose = true;
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  validateCP(): void {
    this.cpaHasWhiteSpaces = this.examForm.controls.codigoPostalArgentino.value.includes(' ');
    this.cpHasWhiteSpaces = this.examForm.controls.codigoPostal.value.includes(' ');
  }

  /**
   * función que recibe el trigger desde el componente attach-upload-file
   * con el objeto actualizado de la lista de archivos y errores
   * @param  {object} event
   * @example:
   *  {
   *    errors: {
   *      isSizeValid: false
   *      isTypeValid: false,
   *    },
   *    data: [
   *       {
   *        archivoBase64: todounstringpegado,
   *        nombreOriginal: "example.png",
   *        tipo: "png",
   *        size: 121354,
   *        esAlta:false,
   *        esBaja:false
   *    ],
   *    invalid: false,
   *    isEmpty: true,
   *    attachedFilesValidQuantity: 0
   *  }
   */
   getAttachedFiles(event: any): any {
    const {errors} = event;

    this.attachedFiles = event;
    if (errors.isSizeValid && errors.isTypeValid) {
      // asigno la data al objeto para enviar
      return false;
    }
  }

  cargarFormulario(): any {
    let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
      ? this.examen.tipoEstudio.tipoEstudioCod
      : this.examen.tipoEstudio;
    this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
    this.configForm.name = this.examen.provinciaNombreEstudio;
    this.examForm = this.configForm.examForm;
    this.examen.puestoTrabajador ?
      this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
    this.examen.antiguedadPuestoTrabajador ?
      this.examForm.controls.antiguedadPuestoTrabajador.setValue(this._standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
    this.examen.fechaIngresoEmpresa ?
      this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
    this.restrictDateIngresoEmpresa();
    this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
    this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
    this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
    this.examen.trabajador.calle ? this.examForm.controls.calle.setValue(this.examen.trabajador.calle) : null;
    this.examen.trabajador.numeroCalle ? this.examForm.controls.numeroCalle.setValue(this.examen.trabajador.numeroCalle) : null;
    this.examen.trabajador.piso ? this.examForm.controls.piso.setValue(this.examen.trabajador.piso) : null;
    this.examen.trabajador.departamento ? this.examForm.controls.departamento.setValue(this.examen.trabajador.departamento) : null;
    this.examen.trabajador.localidad ? this.examForm.controls.localidad.setValue(this.examen.trabajador.localidad) : null;
    this.examen.trabajador.codigoPostal ? this.examForm.controls.codigoPostal.setValue(this.examen.trabajador.codigoPostal) : null;
    this.examen.trabajador.codigoPostalArgentino ? this.examForm.controls.codigoPostalArgentino.setValue(this.examen.trabajador.codigoPostalArgentino) : null;
    this.examen.trabajador.telefono ? this.examForm.controls.telefono.setValue(this.examen.trabajador.telefono) : null;
    this.examen.trabajador.sector ? this.examForm.controls.sector.setValue(this.examen.trabajador.sector) : null;
    this.calculateAge();

    if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {

      /*********************
       * * Campos del Header
       *********************/

      // *FECHA DE REALIZACION
      this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);

      this.setValuesOnFormOnVerOrEditMode();
    }
  }

  _standarizeDate(date: any) {
    let splitedDate = date.replace(/\//g, '-');
    const dateParts = splitedDate.split('-');
    if (date.includes('/')) {
      return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
    } else {
      return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
    }
  }

  // ESPECIALIDADES
  async getEspecialidades(): Promise<void> {
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.especialidades = especialidadesListFromOffline;
  }

  capitalize(word: string): string {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  calcularAntiguedad(): any {
    if (this.examen.fechaAltaEmpleado) {
      this.seniority = moment().diff(
        moment(this.examen.fechaAltaEmpleado),
        'years'
      );
      if (this.seniority > 1) {
        this.unidadTiempo = 'años';
      } else if (this.seniority < 1) {
        this.seniority = moment().diff(
          moment(this.examen.fechaAltaEmpleado),
          'months'
        );
        if (this.seniority > 1) {
          this.unidadTiempo = 'meses';
        } else {
          this.unidadTiempo = 'mes';
        }
      } else {
        this.unidadTiempo = 'año';
      }
    }
  }

  async getTiposDictamen(): Promise<void> {
    const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
    this.tiposDictamen = dataFromOffline.filter(
      (x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
    );
  }

  goBack(ruta?): void {
    if (this.examForm.dirty) {
      this.confirm(ruta);
    } else {
      this.returnToExams();
    }
  }

  confirm(ruta?): void {
    this.confirmationService.confirm({
      header: `¿Está seguro que desea cancelar la carga del examen?`,
      message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
      key: 'goBackForm',
      accept: () => {
        this.returnToExams(ruta);
      },
    });
  }

  returnToExams(ruta?): void {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }

  private saveToOnline(): void {
    this.templateEService.loadExam(this.buildRequest(), this.configForm.baseUrl)
      .subscribe(
        (response) => {
          this.databaseService.deleteItemFromTable(this.examen.id,
            `examenes${(this.examen.categoriaExamen === 'periodicos'
              ? 'Periodicos'
              : 'Reevaluacion')}`);
          this.databaseService.deleteItemFromTable(this.examen.id,
            `examenes${(this.examen.categoriaExamen === 'periodicos'
              ? 'PeriodicosFiltrados'
              : 'ReevaluacionFiltrados')}`);
          this.openSuccessAlert(response.message, 'examen');
        },
        (error) => {
          this.formatResponseAndOpenError(error);
        }
      );
  }

  private saveToOffline(): void {
    const dataToSend = this.buildRequest();
    dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
    dataToSend.cargadoOffline = true;
    const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

    this.databaseService
      .setExameneOnExamenesPorEnviarTable(
        this.examen,
        dataToSend,
        false,
        this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion',
        this.templateEService.buildUrlApi(this.configForm.baseUrl)
      )
      .then((response) => {
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${(this.examen.categoriaExamen === 'periodicos'
            ? 'Periodicos'
            : 'Reevaluacion')}`);
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${(this.examen.categoriaExamen === 'periodicos'
            ? 'PeriodicosFiltrados'
            : 'ReevaluacionFiltrados')}`);
        this.backgroundSyncService.registerEvent('save-examen');
        this.openSuccessAlert(
          details,
          'examen'
        );
      })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ha ocurrido un error. Por favor reintente más tarde y disculpe las molestias ocasionadas',
          key: 'examen',
        });
      });
  }

  private buildRequest(): any {
    let examFormData = { ...this.examForm.getRawValue() };
    let trabajador = {
      apellidoNombre: this.examForm.controls.apellidoNombre.value,
      fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format(
        'yyyy-MM-DD'
      ),
      calle: this.examForm.controls.calle.value,
      numeroCalle: this.examForm.controls.numeroCalle.value,
      piso: this.examForm.controls.piso.value,
      departamento: this.examForm.controls.departamento.value,
      localidad: this.examForm.controls.localidad.value,
      codigoPostal: this.examForm.controls.codigoPostal.value,
      codigoPostalArgentino: this.examForm.controls.codigoPostalArgentino.value,
      telefono: this.examForm.controls.telefono.value,
      sector: this.examForm.controls.sector.value,
      edad: this.examForm.controls.edad.value
    };
    examFormData.trabajador = trabajador;
    examFormData.userId = this.currentUser.userId;
    examFormData.username = this.currentUser.username;
    examFormData.modelId = this.currentUser.modelId;
    examFormData.modelCode = this.currentUser.modelCode;
    examFormData.modelName = this.currentUser.modelName;
    examFormData.tipoEstudio = this.configForm.code;
    examFormData.examenNumero = this.examen.id;
    examFormData.medicoMatricula = examFormData.matricula;
    examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format(
      'yyyy-MM-DD'
    );
    examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format(
      'yyyy-MM-DD'
    );
    examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
    this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
    examFormData.adjuntos = this.attachedFiles.data;
    examFormData.medicoFirmaB64 = this.medicoFirmaB64;
    examFormData.medicoFirmaSigString = this.medicoFirmaSigString;
    examFormData.exFumador = this.examForm.controls.exFumador.value ? this.examForm.controls.exFumador.value : false;
    examFormData.fumaUnoDiez = this.examForm.controls.exFumador.value ? null : this.examForm.controls.fumaUnoDiez.value;
    examFormData.fumaOnceVeinte = this.examForm.controls.exFumador.value ? null : this.examForm.controls.fumaOnceVeinte.value;
    examFormData.fumaMasVeinte = this.examForm.controls.exFumador.value ? null : this.examForm.controls.fumaMasVeinte.value;
    examFormData.exFumadorUnoDiez = this.examForm.controls.exFumador.value ? this.examForm.controls.fumaUnoDiez.value : null;
    examFormData.exFumadorOnceVeinte = this.examForm.controls.exFumador.value ? this.examForm.controls.fumaOnceVeinte.value : null;
    examFormData.exFumadorMasVeinte = this.examForm.controls.exFumador.value ? this.examForm.controls.fumaMasVeinte.value : null;
    return examFormData;
  }

  clickCheckBox(valor, event) {
    switch (valor) {
      case 'noFumador':
        this.examForm.controls.fumador.setValue(false);
        this.examForm.controls.exFumador.setValue(false);
        this.seccionTabaquismo(false);
        break;
      case 'fumador':
        this.examForm.controls.noFumador.setValue(false);
        this.examForm.controls.exFumador.setValue(false);
        this.seccionTabaquismo(event.checked);
        break;
      case 'exFumador':
        this.examForm.controls.fumador.setValue(false);
        this.examForm.controls.noFumador.setValue(false);
        this.seccionTabaquismo(event.checked);
        break;
      case 'fumaUnoDiez':
        this.examForm.controls.fumaOnceVeinte.setValue(false);
        this.examForm.controls.fumaMasVeinte.setValue(false);
        break;
      case 'fumaOnceVeinte':
        this.examForm.controls.fumaUnoDiez.setValue(false);
        this.examForm.controls.fumaMasVeinte.setValue(false);
        break;
      case 'fumaMasVeinte':
        this.examForm.controls.fumaOnceVeinte.setValue(false);
        this.examForm.controls.fumaUnoDiez.setValue(false);
        break;
      /* case 'otrosPielAlteraciones':
        this.habilitarCampo(event.checked, "pielDescripcion");
        if(event.checked) {
          this.examForm.controls.pielLocalizacion.enable();
          this.examForm.controls.pielLocalizacion.setValidators([
            Validators.required,
            Validators.maxLength(25),
          ]);
        } else {
          this.examForm.controls.pielLocalizacion.disable();
          this.examForm.controls.pielLocalizacion.setValue(null);
          this.examForm.controls.pielLocalizacion.setValidators(null);
        }
        this.examForm.controls.pielLocalizacion.updateValueAndValidity();
        break; */
      case 'otrosOjos':
        this.habilitarCampo(event.checked, "descripcionOjos");
        break;
      case 'otrosCavidadOral':
        this.habilitarCampo(event.checked, "descripcionCavidadOral");
        break;
      case 'varices':
        this.seccionVarices(event.checked);
        break;
      case 'hernia':
        this.seccionHernia(event.checked);
        break;
      case 'otrasAbdomen':
        this.habilitarCampo(event.checked, "descripcionAbdomen");
        break;
    }
  }

  validateCheckboxItems(): void {
    if ((!this.examForm.controls.fumador.value && !this.examForm.controls.noFumador.value && !this.examForm.controls.exFumador.value) ||
    (this.examForm.controls.cardiocirculatorioAlteraciones.value && !this.examForm.controls.arritmia.value && !this.examForm.controls.soplos.value
    && !this.examForm.controls.varices.value) || (this.examForm.controls.abdomenAlteraciones.value && !this.examForm.controls.hepatomegalia.value
    && !this.examForm.controls.cicatricesQuirurgicas.value && !this.examForm.controls.esplenomegalia.value && !this.examForm.controls.hernia.value
    && !this.examForm.controls.otrasAbdomen.value) || ((this.examForm.controls.fumador.value || this.examForm.controls.exFumador.value)
    && !this.examForm.controls.fumaUnoDiez.value && !this.examForm.controls.fumaOnceVeinte.value && !this.examForm.controls.fumaMasVeinte.value) ||
    (this.examForm.controls.pielAlteraciones.value && !this.examForm.controls.prurito.value && !this.examForm.controls.vesiculas.value
    && !this.examForm.controls.eritema.value && !this.examForm.controls.ulceracion.value && !this.examForm.controls.botonAceite.value
    && !this.examForm.controls.hiperpigmentacion.value && !this.examForm.controls.hipopigmentacion.value && !this.examForm.controls.eczema.value
    && !this.examForm.controls.otrosPielAlteraciones.value && !this.examForm.controls.fisuras.value && !this.examForm.controls.hiperqueratosis.value
    && !this.examForm.controls.petequias.value && !this.examForm.controls.onicomicosis.value) || (this.examForm.controls.ojosAlteraciones.value
    && !this.examForm.controls.irritacionConjuntival.value && !this.examForm.controls.alteracionVisionColores.value
    && !this.examForm.controls.cicatricesCornea.value && !this.examForm.controls.cataratas.value
    && !this.examForm.controls.nistagmus.value && !this.examForm.controls.visionMonocular.value && !this.examForm.controls.otrosOjos.value) ||
    (this.examForm.controls.cavidadOralAlteraciones.value && !this.examForm.controls.sangradoEncias.value && !this.examForm.controls.faltaPiezaDental.value
    && !this.examForm.controls.ribeteGengival.value && !this.examForm.controls.alteracionEsmalteDentario.value
    && !this.examForm.controls.cariesMultiples.value && !this.examForm.controls.otrosCavidadOral.value) ||
    (this.examForm.controls.rinoscopiaAlteraciones.value && !this.examForm.controls.mucosaNasalPalida.value
    && !this.examForm.controls.mucosaNasalUlcerada.value && !this.examForm.controls.perforacionTabiqueNasal.value
    && !this.examForm.controls.narizInflamada.value) || (this.examForm.controls.osteoarticularAlteraciones.value
    && !this.examForm.controls.miembroSuperiorIzq.value && !this.examForm.controls.miembroSuperiorDer.value
    && !this.examForm.controls.manoDer.value && !this.examForm.controls.manoIzq.value && !this.examForm.controls.dedosManoDerecha.value
    && !this.examForm.controls.dedosManoIzquierda.value && !this.examForm.controls.rodillaIzq.value && !this.examForm.controls.rodillaDer.value
    && !this.examForm.controls.pieIzq.value && !this.examForm.controls.miembroInferiorDer.value && !this.examForm.controls.pieDer.value
    && !this.examForm.controls.miembroInferiorIzq.value) || (this.examForm.controls.examenNeurologicoAlteraciones.value
    && !this.examForm.controls.rombergAnormal.value && !this.examForm.controls.coordinacion.value && !this.examForm.controls.marcha.value
    && !this.examForm.controls.temblor.value && !this.examForm.controls.sensibilidad.value && !this.examForm.controls.reflejos.value
    && !this.examForm.controls.pruebaDedoNariz.value && !this.examForm.controls.alteracionImportanteSentidoOlfato.value)) {
      this.invalidField = true;
    } else {
      this.invalidField = false;
    }
  }

  seccionTabaquismo(checked): void {
    if (checked) {
      this.examForm.controls.fumaUnoDiez.enable();
      this.examForm.controls.fumaOnceVeinte.enable();
      this.examForm.controls.fumaMasVeinte.enable();
      this.examForm.controls.cantidadFuma.enable();
      this.examForm.controls.unidadTiempo.enable();
      this.examForm.controls.cantidadFuma.setValidators(Validators.required);
      this.examForm.controls.unidadTiempo.setValidators(Validators.required);
    } else {
      this.examForm.controls.fumaUnoDiez.disable();
      this.examForm.controls.fumaOnceVeinte.disable();
      this.examForm.controls.fumaMasVeinte.disable();
      this.examForm.controls.cantidadFuma.disable();
      this.examForm.controls.unidadTiempo.disable();
      this.examForm.controls.fumaUnoDiez.setValue(false);
      this.examForm.controls.fumaOnceVeinte.setValue(false);
      this.examForm.controls.fumaMasVeinte.setValue(false);
      this.examForm.controls.cantidadFuma.setValue(null);
      this.examForm.controls.unidadTiempo.setValue(null);
      this.examForm.controls.cantidadFuma.setValidators(null);
      this.examForm.controls.unidadTiempo.setValidators(null);
    }
    this.examForm.controls.cantidadFuma.updateValueAndValidity();
    this.examForm.controls.unidadTiempo.updateValueAndValidity();
  }

  seccionVarices(checked): void {
    let camposVarices = Array.from(document.getElementsByClassName("tableVarices"));
    if (checked) {
      camposVarices.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].enable();
      });
      this.enableTableVarices = true;
      this.examForm.controls.hemorroides.enable();
      this.examForm.controls.hemorroides.setValue(false);
    } else {
      camposVarices.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].disable();
        this.examForm.controls[campo.attributes["formControlName"].value].setValue(false);
      });
      this.examForm.controls.hemorroides.disable();
      this.examForm.controls.realizaTratHemorroides.disable();
      this.examForm.controls.hemorroides.setValue(null);
      this.examForm.controls.realizaTratHemorroides.setValue(null);
      this.habilitarCampo(checked, "descripcionRealizaTratHemorroides");
      this.enableTableVarices = false;
    }
  }

  seccionHernia(checked): void {
    let camposHernias = Array.from(document.getElementsByClassName("tableHernias"));
    if (checked) {
      camposHernias.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].enable();
      });
      this.enableTableHernias = true;
      this.examForm.controls.umbilical.enable();
      this.examForm.controls.dolorMolestiaRegionInguinal.enable();
      this.examForm.controls.herniaIncipiente.enable();
      this.examForm.controls.anilloHerniarioComplaciente.enable();
      this.examForm.controls.umbilical.setValue(false);
      this.examForm.controls.herniaIncipiente.setValue(false);
      this.examForm.controls.anilloHerniarioComplaciente.setValue(false);
      this.examForm.controls.umbilical.setValidators(Validators.required);
      this.examForm.controls.dolorMolestiaRegionInguinal.setValidators(Validators.required);
      this.examForm.controls.herniaIncipiente.setValidators(Validators.required);
      this.examForm.controls.anilloHerniarioComplaciente.setValidators(Validators.required);
    } else {
      camposHernias.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].disable();
        this.examForm.controls[campo.attributes["formControlName"].value].setValue(false);
      });
      this.examForm.controls.umbilical.disable();
      this.examForm.controls.dolorMolestiaRegionInguinal.disable();
      this.examForm.controls.herniaIncipiente.disable();
      this.examForm.controls.anilloHerniarioComplaciente.disable();
      this.examForm.controls.umbilical.setValue(null);
      this.examForm.controls.dolorMolestiaRegionInguinal.setValue(null);
      this.examForm.controls.herniaIncipiente.setValue(null);
      this.examForm.controls.anilloHerniarioComplaciente.setValue(null);
      this.examForm.controls.umbilical.setValidators(null);
      this.examForm.controls.dolorMolestiaRegionInguinal.setValidators(null);
      this.examForm.controls.herniaIncipiente.setValidators(null);
      this.examForm.controls.anilloHerniarioComplaciente.setValidators(null);
      this.enableTableHernias = false;
    }
    this.examForm.controls.umbilical.updateValueAndValidity();
    this.examForm.controls.dolorMolestiaRegionInguinal.updateValueAndValidity();
    this.examForm.controls.herniaIncipiente.updateValueAndValidity();
    this.examForm.controls.anilloHerniarioComplaciente.updateValueAndValidity();
  }

  clickTableVarices(valor, checked) {
    if(checked) {
      switch (valor) {
        case 'c0mizq':
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c0mder':
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c0bilateral':
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c0asintomatico':
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c0sintomatico':
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c1mizq':
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c1mder':
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c1bilateral':
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c1asintomatico':
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c1sintomatico':
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c2mizq':
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c2mder':
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c2bilateral':
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c2asintomatico':
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c2sintomatico':
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c3mizq':
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c3mder':
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c3bilateral':
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c3asintomatico':
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c3sintomatico':
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c4amizq':
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c4amder':
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c4abilateral':
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c4aasintomatico':
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c4asintomatico':
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c4bmizq':
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c4bmder':
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c4bbilateral':
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c4basintomatico':
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c4bsintomatico':
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c5mizq':
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c5mder':
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c5bilateral':
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c5asintomatico':
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c5sintomatico':
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c6mizq':
          this.examForm.controls.c6mder.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          break;
        case 'c6mder':
          this.examForm.controls.c6mizq.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          break;
        case 'c6bilateral':
          this.examForm.controls.c6mder.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          break;
        case 'c6asintomatico':
          this.examForm.controls.c6sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          break;
        case 'c6sintomatico':
          this.examForm.controls.c6asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          break;
      }
    }
    this.validateCuadroVarices();
  }

  clickTableHernias(valor, checked) {
    if(checked) {
      switch (valor) {
        case 'inguinalDirectaDerecha':
          this.examForm.controls.inguinalDirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalDirectaBilateral.setValue(false);
          this.examForm.controls.inguinalIndirectaDerecha.setValue(false);
          this.examForm.controls.inguinalMixtaDerecha.setValue(false);
          this.examForm.controls.curalDerecha.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalDirectaIzquierda':
          this.examForm.controls.inguinalDirectaDerecha.setValue(false);
          this.examForm.controls.inguinalDirectaBilateral.setValue(false);
          this.examForm.controls.inguinalIndirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalMixtaIzquierda.setValue(false);
          this.examForm.controls.curalIzquierda.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalDirectaBilateral':
          this.examForm.controls.inguinalDirectaDerecha.setValue(false);
          this.examForm.controls.inguinalDirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalIndirectaBilateral.setValue(false);
          this.examForm.controls.inguinalMixtaBilateral.setValue(false);
          this.examForm.controls.curalBilateral.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalDirectaReductible':
          !this.examForm.controls.inguinalDirectaBilateral.value ? this.examForm.controls.inguinalDirectaNoReductible.setValue(false) : null;
          break;
        case 'inguinalDirectaNoReductible':
          !this.examForm.controls.inguinalDirectaBilateral.value ? this.examForm.controls.inguinalDirectaReductible.setValue(false) : null;
          break;
        case 'inguinalIndirectaDerecha':
          this.examForm.controls.inguinalIndirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalIndirectaBilateral.setValue(false);
          this.examForm.controls.inguinalDirectaDerecha.setValue(false);
          this.examForm.controls.inguinalMixtaDerecha.setValue(false);
          this.examForm.controls.curalDerecha.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalIndirectaIzquierda':
          this.examForm.controls.inguinalIndirectaDerecha.setValue(false);
          this.examForm.controls.inguinalIndirectaBilateral.setValue(false);
          this.examForm.controls.inguinalDirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalMixtaIzquierda.setValue(false);
          this.examForm.controls.curalIzquierda.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalIndirectaBilateral':
          this.examForm.controls.inguinalIndirectaDerecha.setValue(false);
          this.examForm.controls.inguinalIndirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalDirectaBilateral.setValue(false);
          this.examForm.controls.inguinalMixtaBilateral.setValue(false);
          this.examForm.controls.curalBilateral.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalIndirectaReductible':
          !this.examForm.controls.inguinalIndirectaBilateral.value ? this.examForm.controls.inguinalIndirectaNoReductible.setValue(false) : null;
          break;
        case 'inguinalIndirectaNoReductible':
          !this.examForm.controls.inguinalIndirectaBilateral.value ? this.examForm.controls.inguinalIndirectaReductible.setValue(false) : null;
          break;
        case 'inguinalMixtaDerecha':
          this.examForm.controls.inguinalMixtaIzquierda.setValue(false);
          this.examForm.controls.inguinalMixtaBilateral.setValue(false);
          this.examForm.controls.inguinalIndirectaDerecha.setValue(false);
          this.examForm.controls.inguinalDirectaDerecha.setValue(false);
          this.examForm.controls.curalDerecha.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalMixtaIzquierda':
          this.examForm.controls.inguinalMixtaDerecha.setValue(false);
          this.examForm.controls.inguinalMixtaBilateral.setValue(false);
          this.examForm.controls.inguinalIndirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalDirectaIzquierda.setValue(false);
          this.examForm.controls.curalIzquierda.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalMixtaBilateral':
          this.examForm.controls.inguinalMixtaDerecha.setValue(false);
          this.examForm.controls.inguinalMixtaIzquierda.setValue(false);
          this.examForm.controls.inguinalIndirectaBilateral.setValue(false);
          this.examForm.controls.inguinalDirectaBilateral.setValue(false);
          this.examForm.controls.curalBilateral.setValue(false);
          this.cleanBilateral();
          break;
        case 'inguinalMixtaReductible':
          !this.examForm.controls.inguinalMixtaBilateral.value ? this.examForm.controls.inguinalMixtaNoReductible.setValue(false) : null;
          break;
        case 'inguinalMixtaNoReductible':
          !this.examForm.controls.inguinalMixtaBilateral.value ? this.examForm.controls.inguinalMixtaReductible.setValue(false) : null;
          break;
        case 'curalDerecha':
          this.examForm.controls.curalIzquierda.setValue(false);
          this.examForm.controls.curalBilateral.setValue(false);
          this.examForm.controls.inguinalDirectaDerecha.setValue(false);
          this.examForm.controls.inguinalMixtaDerecha.setValue(false);
          this.examForm.controls.inguinalIndirectaDerecha.setValue(false);
          this.cleanBilateral();
          break;
        case 'curalIzquierda':
          this.examForm.controls.curalDerecha.setValue(false);
          this.examForm.controls.curalBilateral.setValue(false);
          this.examForm.controls.inguinalDirectaIzquierda.setValue(false);
          this.examForm.controls.inguinalMixtaIzquierda.setValue(false);
          this.examForm.controls.inguinalIndirectaIzquierda.setValue(false);
          this.cleanBilateral();
          break;
        case 'curalBilateral':
          this.examForm.controls.curalDerecha.setValue(false);
          this.examForm.controls.curalIzquierda.setValue(false);
          this.examForm.controls.inguinalDirectaBilateral.setValue(false);
          this.examForm.controls.inguinalMixtaBilateral.setValue(false);
          this.examForm.controls.inguinalIndirectaBilateral.setValue(false);
          this.cleanBilateral();
          break;
        case 'curalReductible':
          !this.examForm.controls.curalBilateral.value ? this.examForm.controls.curalNoReductible.setValue(false) : null;
          break;
        case 'curalNoReductible':
          !this.examForm.controls.curalBilateral.value ? this.examForm.controls.curalReductible.setValue(false) : null;
          break;
      }
    }
    this.validateCuadroHernias();
  }

  private cleanBilateral() {
    if(!this.examForm.controls.inguinalDirectaBilateral.value && this.examForm.controls.inguinalDirectaReductible.value &&
      this.examForm.controls.inguinalDirectaNoReductible.value) {
      this.examForm.controls.inguinalDirectaReductible.setValue(false);
      this.examForm.controls.inguinalDirectaNoReductible.setValue(false);
    }
    if(!this.examForm.controls.inguinalIndirectaBilateral.value && this.examForm.controls.inguinalIndirectaReductible.value &&
      this.examForm.controls.inguinalIndirectaNoReductible.value) {
      this.examForm.controls.inguinalIndirectaReductible.setValue(false);
      this.examForm.controls.inguinalIndirectaNoReductible.setValue(false);
    }
    if(!this.examForm.controls.inguinalMixtaBilateral.value && this.examForm.controls.inguinalMixtaReductible.value &&
      this.examForm.controls.inguinalMixtaNoReductible.value) {
      this.examForm.controls.inguinalMixtaReductible.setValue(false);
      this.examForm.controls.inguinalMixtaNoReductible.setValue(false);
    }
    if(!this.examForm.controls.curalBilateral.value && this.examForm.controls.curalReductible.value && this.examForm.controls.curalNoReductible.value) {
      this.examForm.controls.curalReductible.setValue(false);
      this.examForm.controls.curalNoReductible.setValue(false);
    }
  }

  validateCuadroVarices() {
    if (this.examForm.controls.varices.value) {
      let countCheckCuadroVarices = 0;
      let camposVarices = Array.from(document.getElementsByClassName("tableVarices"));
      camposVarices.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].value ? countCheckCuadroVarices ++ : null;
      });
      countCheckCuadroVarices > 0 ? this.cuadroVaricesInvalid = false : this.cuadroVaricesInvalid = true;
    } else {
      this.cuadroVaricesInvalid = false;
    }
  }

  validateCuadroHernias() {
    if (this.examForm.controls.hernia.value) {
      let countCheckCuadroHernias = 0;
      let camposHernias = Array.from(document.getElementsByClassName("tableHernias"));
      camposHernias.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].value ? countCheckCuadroHernias ++ : null;
      });
      countCheckCuadroHernias > 0 ? this.cuadroHerniasInvalid = false : this.cuadroHerniasInvalid = true;
    } else {
      this.cuadroHerniasInvalid = false;
    }
  }

  validateSeccionColumna() {
    if (this.examForm.controls.columnaVertebralAlteraciones.value) {
      let countCheckAlteracionesColumna = 0;
      let camposColumna = Array.from(document.getElementsByClassName("alteracionesColumna"));
      camposColumna.forEach(campo => {
        this.examForm.controls[campo.attributes["formControlName"].value].value ? countCheckAlteracionesColumna ++ : null;
      });
      countCheckAlteracionesColumna > 0 ? this.columnaVertebralInvalid = false : this.columnaVertebralInvalid = true;
    } else {
      this.columnaVertebralInvalid = false;
    }
  }

  clickRadioButton(event, campo) {
    switch (campo) {
      case 'PREOCUPACIONAL':
        this.habilitarCampo(event, 'examenPreocupacionalObservacion');
        break;
      case 'SINTOMAS':
        this.habilitarCampo(event, 'descripcionSintomasActividadLaboral');
        break;
      case 'ANTECEDENTES':
        this.seccionAntecedentes(event);
        this.habilitarCampo(event, 'observacionesAntecedentesPersonales');
        break;
      case 'TRATAMIENTO':
        if (event === 'NO') {
          this.examForm.controls.tomaMedicamentos.disable();
          this.examForm.controls.tomaMedicamentos.setValue(null);
          this.examForm.controls.tomaMedicamentos.setValidators(null);
          this.habilitarCampo(event, 'detalleTomaMedicamentos');
        } else {
          this.examForm.controls.tomaMedicamentos.enable();
          this.examForm.controls.tomaMedicamentos.setValue(false);
          this.examForm.controls.tomaMedicamentos.setValidators(Validators.required);
        }
        this.examForm.controls.tomaMedicamentos.updateValueAndValidity();
        this.habilitarCampo(event, 'descripcionTratamiento');
        break;
      case 'MEDICAMENTOS':
        this.habilitarCampo(event, 'detalleTomaMedicamentos');
        break;
      case 'ALCOHOL':
        this.seccionAlcohol(event);
        break;
      case 'PIEL':
        this.seccionPiel(event);
        break;
      case 'OJOS':
        this.seccionOjos(event);
        break;
      case 'CAVIDADORAL':
        this.seccionCavidadOral(event);
        break;
      case 'NARIZ':
        this.habilitarCampo(event, 'observacionesNariz');
        break;
      case 'RINOSCOPIA':
        this.seccionRinoscopia(event);
        break;
      case 'CUELLO':
        this.habilitarCampo(event, 'observacionesCuelloAlteraciones');
        break;
      case 'TORAX':
        this.seccionTorax(event);
        break;
      case 'CARDIOCIRCULATORIO':
        this.seccionCardiocirculatorio(event);
        break;
      case 'HEMORROIDES':
        if (event === 'NO') {
          this.examForm.controls.realizaTratHemorroides.disable();
          this.examForm.controls.realizaTratHemorroides.setValue(null);
          this.examForm.controls.realizaTratHemorroides.setValidators(null);
          this.habilitarCampo(event, 'descripcionRealizaTratHemorroides');
        } else {
          this.examForm.controls.realizaTratHemorroides.enable();
          this.examForm.controls.realizaTratHemorroides.setValue(false);
          this.examForm.controls.realizaTratHemorroides.setValidators(Validators.required);
        }
        this.examForm.controls.realizaTratHemorroides.updateValueAndValidity();
        break;
      case 'TRAT_HEMORROIDES':
        this.habilitarCampo(event, 'descripcionRealizaTratHemorroides');
        break;
      case 'ABDOMEN':
        this.seccionAbdomen(event);
        break;
      case 'COLUMNA':
        this.seccionColumna(event);
        break;
      case 'OSTEO':
        this.seccionOsteoarticular(event);
        break;
      case 'NEUROLOGICO':
        this.seccionNeurologico(event);
        break;
    }
  }

  habilitarCampo(event, field): void {
    if (event === 'NO' || !event ) {
      this.examForm.controls[field].disable();
      this.examForm.controls[field].setValue('');
      this.examForm.controls[field].setValidators(null);
    } else {
      this.examForm.controls[field].enable();
      this.examForm.controls[field].setValidators([
        Validators.required,
        Validators.maxLength(1000),
      ]);
    }
    this.examForm.controls[field].updateValueAndValidity();
  }

  seccionAntecedentes(event) {
    if (event === 'NO') {
      this.examForm.controls.realizaTratamiento.disable();
      this.examForm.controls.realizaTratamiento.setValue(false);
      this.examForm.controls.realizaTratamiento.setValidators(null);
      this.clickRadioButton(event, "TRATAMIENTO");
      this.clickRadioButton(event, "MEDICAMENTOS");
    } else {
      this.examForm.controls.realizaTratamiento.enable();
      this.examForm.controls.realizaTratamiento.setValidators(Validators.required);
    }
    this.examForm.controls.realizaTratamiento.updateValueAndValidity();
  }

  seccionAlcohol(event) {
    if (event === 'NO') {
      this.examForm.controls.cantidadAlcohol.disable();
      this.examForm.controls.cantidadAlcohol.setValue(null);
      this.examForm.controls.cantidadAlcohol.setValidators(null);
      this.examForm.controls.tipoAlcohol.disable();
      this.examForm.controls.tipoAlcohol.setValue(null);
      this.examForm.controls.tipoAlcohol.setValidators(null);
    } else {
      this.examForm.controls.cantidadAlcohol.enable();
      this.examForm.controls.cantidadAlcohol.setValidators(Validators.required);
      this.examForm.controls.tipoAlcohol.enable();
      this.examForm.controls.tipoAlcohol.setValidators(Validators.required);
    }
    this.examForm.controls.cantidadAlcohol.updateValueAndValidity();
    this.examForm.controls.tipoAlcohol.updateValueAndValidity();
  }

  seccionPiel(event) {
    if (event === 'NO') {
      this.examForm.controls.vesiculas.disable();
      this.examForm.controls.botonAceite.disable();
      this.examForm.controls.eczema.disable();
      this.examForm.controls.otrosPielAlteraciones.disable();
      this.examForm.controls.prurito.disable();
      this.examForm.controls.hiperpigmentacion.disable();
      this.examForm.controls.hipopigmentacion.disable();
      this.examForm.controls.eritema.disable();
      this.examForm.controls.fisuras.disable();
      this.examForm.controls.hiperqueratosis.disable();
      this.examForm.controls.ulceracion.disable();
      this.examForm.controls.petequias.disable();
      this.examForm.controls.onicomicosis.disable();
      this.examForm.controls.vesiculas.setValue(false);
      this.examForm.controls.botonAceite.setValue(false);
      this.examForm.controls.eczema.setValue(false);
      this.examForm.controls.otrosPielAlteraciones.setValue(false);
      this.examForm.controls.prurito.setValue(false);
      this.examForm.controls.hiperpigmentacion.setValue(false);
      this.examForm.controls.hipopigmentacion.setValue(false);
      this.examForm.controls.eritema.setValue(false);
      this.examForm.controls.fisuras.setValue(false);
      this.examForm.controls.hiperqueratosis.setValue(false);
      this.examForm.controls.ulceracion.setValue(false);
      this.examForm.controls.petequias.setValue(false);
      this.examForm.controls.onicomicosis.setValue(false);
      this.examForm.controls.observacionesPiel.setValidators([
        Validators.maxLength(1000),
      ]);
      //this.habilitarCampo(event, "pielDescripcion");
      //this.habilitarCampo(event, "pielLocalizacion");
    } else {
      this.examForm.controls.vesiculas.enable();
      this.examForm.controls.botonAceite.enable();
      this.examForm.controls.eczema.enable();
      this.examForm.controls.otrosPielAlteraciones.enable();
      this.examForm.controls.prurito.enable();
      this.examForm.controls.hiperpigmentacion.enable();
      this.examForm.controls.hipopigmentacion.enable();
      this.examForm.controls.eritema.enable();
      this.examForm.controls.fisuras.enable();
      this.examForm.controls.hiperqueratosis.enable();
      this.examForm.controls.ulceracion.enable();
      this.examForm.controls.petequias.enable();
      this.examForm.controls.onicomicosis.enable();
      this.examForm.controls.observacionesPiel.setValidators([
        Validators.required,
        Validators.maxLength(1000),
      ]);
    }
    this.examForm.controls.observacionesPiel.updateValueAndValidity();
  }

  seccionOjos(event) {
    if (event === 'NO') {
      this.examForm.controls.irritacionConjuntival.disable();
      this.examForm.controls.alteracionVisionColores.disable();
      this.examForm.controls.cicatricesCornea.disable();
      this.examForm.controls.cataratas.disable();
      this.examForm.controls.nistagmus.disable();
      this.examForm.controls.visionMonocular.disable();
      this.examForm.controls.otrosOjos.disable();
      this.examForm.controls.irritacionConjuntival.setValue(false);
      this.examForm.controls.alteracionVisionColores.setValue(false);
      this.examForm.controls.cicatricesCornea.setValue(false);
      this.examForm.controls.cataratas.setValue(false);
      this.examForm.controls.nistagmus.setValue(false);
      this.examForm.controls.visionMonocular.setValue(false);
      this.examForm.controls.otrosOjos.setValue(false);
      this.habilitarCampo(event, "descripcionOjos");
    } else {
      this.examForm.controls.irritacionConjuntival.enable();
      this.examForm.controls.alteracionVisionColores.enable();
      this.examForm.controls.cicatricesCornea.enable();
      this.examForm.controls.cataratas.enable();
      this.examForm.controls.nistagmus.enable();
      this.examForm.controls.visionMonocular.enable();
      this.examForm.controls.otrosOjos.enable();
    }
  }

  seccionCavidadOral(event) {
    if (event === 'NO') {
      this.examForm.controls.sangradoEncias.disable();
      this.examForm.controls.faltaPiezaDental.disable();
      this.examForm.controls.ribeteGengival.disable();
      this.examForm.controls.alteracionEsmalteDentario.disable();
      this.examForm.controls.cariesMultiples.disable();
      this.examForm.controls.otrosCavidadOral.disable();
      this.examForm.controls.sangradoEncias.setValue(false);
      this.examForm.controls.faltaPiezaDental.setValue(false);
      this.examForm.controls.ribeteGengival.setValue(false);
      this.examForm.controls.alteracionEsmalteDentario.setValue(false);
      this.examForm.controls.cariesMultiples.setValue(false);
      this.examForm.controls.otrosCavidadOral.setValue(false);
      this.habilitarCampo(event, "descripcionCavidadOral");
    } else {
      this.examForm.controls.sangradoEncias.enable();
      this.examForm.controls.faltaPiezaDental.enable();
      this.examForm.controls.ribeteGengival.enable();
      this.examForm.controls.alteracionEsmalteDentario.enable();
      this.examForm.controls.cariesMultiples.enable();
      this.examForm.controls.otrosCavidadOral.enable();
    }
  }

  seccionRinoscopia(event) {
    if (event === 'NO') {
      this.examForm.controls.mucosaNasalPalida.disable();
      this.examForm.controls.mucosaNasalUlcerada.disable();
      this.examForm.controls.perforacionTabiqueNasal.disable();
      this.examForm.controls.narizInflamada.disable();
      this.examForm.controls.mucosaNasalPalida.setValue(false);
      this.examForm.controls.mucosaNasalUlcerada.setValue(false);
      this.examForm.controls.perforacionTabiqueNasal.setValue(false);
      this.examForm.controls.narizInflamada.setValue(false);
    } else {
      this.examForm.controls.mucosaNasalPalida.enable();
      this.examForm.controls.mucosaNasalUlcerada.enable();
      this.examForm.controls.perforacionTabiqueNasal.enable();
      this.examForm.controls.narizInflamada.enable();
    }
  }

  seccionTorax(event) {
    if (event === 'NO') {
      this.examForm.controls.roncus.disable();
      this.examForm.controls.crepitantes.disable();
      this.examForm.controls.sibilancias.disable();
      this.examForm.controls.subCrepitantes.disable();
      this.examForm.controls.disnea.disable();
      this.examForm.controls.deformacionesTorax.disable();
      this.examForm.controls.roncus.setValue(false);
      this.examForm.controls.crepitantes.setValue(false);
      this.examForm.controls.sibilancias.setValue(false);
      this.examForm.controls.subCrepitantes.setValue(false);
      this.examForm.controls.disnea.setValue(false);
      this.examForm.controls.deformacionesTorax.setValue(false);
    } else {
      this.examForm.controls.roncus.enable();
      this.examForm.controls.crepitantes.enable();
      this.examForm.controls.sibilancias.enable();
      this.examForm.controls.subCrepitantes.enable();
      this.examForm.controls.disnea.enable();
      this.examForm.controls.deformacionesTorax.enable();
    }
  }

  seccionCardiocirculatorio(event) {
    if (event === 'NO') {
      this.examForm.controls.arritmia.disable();
      this.examForm.controls.soplos.disable();
      this.examForm.controls.varices.disable();
      this.examForm.controls.arritmia.setValue(false);
      this.examForm.controls.soplos.setValue(false);
      this.examForm.controls.varices.setValue(false);
      this.seccionVarices(false);
      this.clickRadioButton(event, "HEMORROIDES");
    } else {
      this.examForm.controls.arritmia.enable();
      this.examForm.controls.soplos.enable();
      this.examForm.controls.varices.enable();
    }
  }

  seccionAbdomen(event) {
    if (event === 'NO') {
      this.examForm.controls.hepatomegalia.disable();
      this.examForm.controls.cicatricesQuirurgicas.disable();
      this.examForm.controls.esplenomegalia.disable();
      this.examForm.controls.hernia.disable();
      this.examForm.controls.otrasAbdomen.disable();
      this.examForm.controls.hepatomegalia.setValue(false);
      this.examForm.controls.cicatricesQuirurgicas.setValue(false);
      this.examForm.controls.esplenomegalia.setValue(false);
      this.examForm.controls.hernia.setValue(false);
      this.examForm.controls.otrasAbdomen.setValue(false);
      this.habilitarCampo(event, "descripcionAbdomen");
      this.seccionHernia(false);
    } else {
      this.examForm.controls.hepatomegalia.enable();
      this.examForm.controls.cicatricesQuirurgicas.enable();
      this.examForm.controls.esplenomegalia.enable();
      this.examForm.controls.hernia.enable();
      this.examForm.controls.otrasAbdomen.enable();
    }
  }

  seccionColumna(event) {
    if (event === 'NO') {
      this.examForm.controls.cicatricesQuirurgicasCc.disable();
      this.examForm.controls.cicatricesQuirurgicasCd.disable();
      this.examForm.controls.cicatricesQuirurgicasCls.disable();
      this.examForm.controls.contracturaMuscularCc.disable();
      this.examForm.controls.contracturaMuscularCd.disable();
      this.examForm.controls.contracturaMuscularCls.disable();
      this.examForm.controls.leseguePositivoDer.disable();
      this.examForm.controls.leseguePositivoIzq.disable();
      this.examForm.controls.puntosDolorososCc.disable();
      this.examForm.controls.puntosDolorososCd.disable();
      this.examForm.controls.puntosDolorososCls.disable();
      this.examForm.controls.deformidadCc.disable();
      this.examForm.controls.deformidadCd.disable();
      this.examForm.controls.deformidadCls.disable();
      this.examForm.controls.limitacionesMovilidadCc.disable();
      this.examForm.controls.limitacionesMovilidadCd.disable();
      this.examForm.controls.limitacionesMovilidadCls.disable();
      this.examForm.controls.cicatricesQuirurgicasCc.setValue(false);
      this.examForm.controls.cicatricesQuirurgicasCd.setValue(false);
      this.examForm.controls.cicatricesQuirurgicasCls.setValue(false);
      this.examForm.controls.contracturaMuscularCc.setValue(false);
      this.examForm.controls.contracturaMuscularCd.setValue(false);
      this.examForm.controls.contracturaMuscularCls.setValue(false);
      this.examForm.controls.leseguePositivoDer.setValue(false);
      this.examForm.controls.leseguePositivoIzq.setValue(false);
      this.examForm.controls.puntosDolorososCc.setValue(false);
      this.examForm.controls.puntosDolorososCd.setValue(false);
      this.examForm.controls.puntosDolorososCls.setValue(false);
      this.examForm.controls.deformidadCc.setValue(false);
      this.examForm.controls.deformidadCd.setValue(false);
      this.examForm.controls.deformidadCls.setValue(false);
      this.examForm.controls.limitacionesMovilidadCc.setValue(false);
      this.examForm.controls.limitacionesMovilidadCd.setValue(false);
      this.examForm.controls.limitacionesMovilidadCls.setValue(false);
      this.columnaVertebralInvalid = false;
    } else {
      this.examForm.controls.cicatricesQuirurgicasCc.enable();
      this.examForm.controls.cicatricesQuirurgicasCd.enable();
      this.examForm.controls.cicatricesQuirurgicasCls.enable();
      this.examForm.controls.contracturaMuscularCc.enable();
      this.examForm.controls.contracturaMuscularCd.enable();
      this.examForm.controls.contracturaMuscularCls.enable();
      this.examForm.controls.leseguePositivoDer.enable();
      this.examForm.controls.leseguePositivoIzq.enable();
      this.examForm.controls.puntosDolorososCc.enable();
      this.examForm.controls.puntosDolorososCd.enable();
      this.examForm.controls.puntosDolorososCls.enable();
      this.examForm.controls.deformidadCc.enable();
      this.examForm.controls.deformidadCd.enable();
      this.examForm.controls.deformidadCls.enable();
      this.examForm.controls.limitacionesMovilidadCc.enable();
      this.examForm.controls.limitacionesMovilidadCd.enable();
      this.examForm.controls.limitacionesMovilidadCls.enable();
      this.columnaVertebralInvalid = true;
    }
  }

  seccionOsteoarticular(event) {
    if (event === 'NO') {
      this.examForm.controls.miembroSuperiorDer.disable();
      this.examForm.controls.dedosManoDerecha.disable();
      this.examForm.controls.rodillaDer.disable();
      this.examForm.controls.miembroSuperiorIzq.disable();
      this.examForm.controls.dedosManoIzquierda.disable();
      this.examForm.controls.rodillaIzq.disable();
      this.examForm.controls.manoDer.disable();
      this.examForm.controls.miembroInferiorDer.disable();
      this.examForm.controls.pieDer.disable();
      this.examForm.controls.manoIzq.disable();
      this.examForm.controls.miembroInferiorIzq.disable();
      this.examForm.controls.pieIzq.disable();
      this.examForm.controls.miembroSuperiorDer.setValue(false);
      this.examForm.controls.dedosManoDerecha.setValue(false);
      this.examForm.controls.rodillaDer.setValue(false);
      this.examForm.controls.miembroSuperiorIzq.setValue(false);
      this.examForm.controls.dedosManoIzquierda.setValue(false);
      this.examForm.controls.rodillaIzq.setValue(false);
      this.examForm.controls.manoDer.setValue(false);
      this.examForm.controls.miembroInferiorDer.setValue(false);
      this.examForm.controls.pieDer.setValue(false);
      this.examForm.controls.manoIzq.setValue(false);
      this.examForm.controls.miembroInferiorIzq.setValue(false);
      this.examForm.controls.pieIzq.setValue(false);
    } else {
      this.examForm.controls.miembroSuperiorDer.enable();
      this.examForm.controls.dedosManoDerecha.enable();
      this.examForm.controls.rodillaDer.enable();
      this.examForm.controls.miembroSuperiorIzq.enable();
      this.examForm.controls.dedosManoIzquierda.enable();
      this.examForm.controls.rodillaIzq.enable();
      this.examForm.controls.manoDer.enable();
      this.examForm.controls.miembroInferiorDer.enable();
      this.examForm.controls.pieDer.enable();
      this.examForm.controls.manoIzq.enable();
      this.examForm.controls.miembroInferiorIzq.enable();
      this.examForm.controls.pieIzq.enable();
    }
  }

  seccionNeurologico(event) {
    if (event === 'NO') {
      this.examForm.controls.rombergAnormal.disable();
      this.examForm.controls.coordinacion.disable();
      this.examForm.controls.marcha.disable();
      this.examForm.controls.temblor.disable();
      this.examForm.controls.sensibilidad.disable();
      this.examForm.controls.pruebaDedoNariz.disable();
      this.examForm.controls.reflejos.disable();
      this.examForm.controls.alteracionImportanteSentidoOlfato.disable();
      this.examForm.controls.rombergAnormal.setValue(false);
      this.examForm.controls.coordinacion.setValue(false);
      this.examForm.controls.marcha.setValue(false);
      this.examForm.controls.temblor.setValue(false);
      this.examForm.controls.sensibilidad.setValue(false);
      this.examForm.controls.pruebaDedoNariz.setValue(false);
      this.examForm.controls.reflejos.setValue(false);
      this.examForm.controls.alteracionImportanteSentidoOlfato.setValue(false);
    } else {
      this.examForm.controls.rombergAnormal.enable();
      this.examForm.controls.coordinacion.enable();
      this.examForm.controls.marcha.enable();
      this.examForm.controls.temblor.enable();
      this.examForm.controls.sensibilidad.enable();
      this.examForm.controls.pruebaDedoNariz.enable();
      this.examForm.controls.reflejos.enable();
      this.examForm.controls.alteracionImportanteSentidoOlfato.enable();
    }
  }

  calcularImc() {
    let imc: number | null = null;
    const peso = this.examForm.controls.peso.value;
    const talla = this.examForm.controls.talla.value;

    const pesoValido = peso >= 40 && peso <= 180;
    const tallaValida = talla >= 100 && talla <= 220;

    if (pesoValido && tallaValida) {
      const tallaEnMetros = talla / 100;
      imc = peso / Math.pow(tallaEnMetros, 2);
    }

    imc !== null
      ? this.examForm.controls.indiceMasaCorporal.setValue(Math.round(imc))
      : this.examForm.controls.indiceMasaCorporal.setValue(null);
  }


  private calculateAge(): any {
    let edad = null;
    if (this.examForm.controls.fechaNacimiento.value) {
      edad = moment().diff(
        moment(this.examForm.controls.fechaNacimiento.value),
        'years'
      );
    }
    this.examForm.controls.edad.setValue(edad);
    this.examen.trabajador.edad = edad;
  }

  restrictDateIngresoEmpresa(): void {
    if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
      this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
    } else {
      this.maxDateIngreso = this.maxDate;
    }
  }

  private navigateInvalidField(classFocus: string): void {
    const invalidFields = [].slice.call(
      document.getElementsByClassName(classFocus)
    );
    window.scroll(0, invalidFields[1].offsetTop - 100);
    invalidFields[1].focus();
  }

  private openSuccessAlert(message: string, key: string): void {
    this.messageAlertServices.setMessage(0, {
      severity: 'success',
      summary: '',
      detail: message,
      key,
    });
    setTimeout(() => {
      this.returnToExams();
    }, 500);
    this.enviandose = false;
  }

  formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

  private openErrorAlert(message: string, key: string): void {
    this.messageAlertServices.setMessage(0, {
      severity: 'error',
      summary: '',
      detail: message,
      key,
    });
    setTimeout(() => {
      const header = document.querySelector('#templateContainer') as any;
      window.scroll(0, header.offsetTop - 150);
    }, 100);
    this.enviandose = false;
  }

  /**
   * @description:
   * * Asignacion de valores a los campos en modo edicion
   */
  private setValuesOnFormOnVerOrEditMode(): void {
    if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {

      /**********************
       *  * Campos del FOOTER
       ***********************/
      this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
      this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
      this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
      this.examForm.controls.matricula.setValue(this.examen.medicoMatricula);
      this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));

      /**********************
       *  * Campos del ESTUDIO
       ***********************/
      this.examForm.controls.responsableMedico.setValue(this.examen.responsableMedico);
      this.examForm.controls.realizacionExamenPreocupacional.setValue(this.examen.realizacionExamenPreocupacional);
      this.examForm.controls.examenPreocupacionalObservacion?.setValue(this.examen.examenPreocupacionalObservacion ?
        this.examen.examenPreocupacionalObservacion : "");
      this.examForm.controls.sintomasActividadLaboral.setValue(this.examen.sintomasActividadLaboral);
      this.examForm.controls.descripcionSintomasActividadLaboral?.setValue(this.examen.descripcionSintomasActividadLaboral ?
        this.examen.descripcionSintomasActividadLaboral : "");
      this.examForm.controls.antecedentesPersonalesEnfermedades.setValue(this.examen.antecedentesPersonalesEnfermedades);
      this.examForm.controls.observacionesAntecedentesPersonales?.setValue(this.examen.observacionesAntecedentesPersonales ?
        this.examen.observacionesAntecedentesPersonales : "");
      this.examForm.controls.realizaTratamiento.setValue(this.examen.realizaTratamiento);
      this.examen.realizaTratamiento && this.examen.modoVista !== 'ver' ? this.clickRadioButton("SI", "TRATAMIENTO") : null;
      this.examForm.controls.descripcionTratamiento?.setValue(this.examen.descripcionTratamiento ?
        this.examen.descripcionTratamiento : "");
      this.examForm.controls.tomaMedicamentos.setValue(this.examen.tomaMedicamentos);
      this.examForm.controls.detalleTomaMedicamentos?.setValue(this.examen.detalleTomaMedicamentos ?
        this.examen.detalleTomaMedicamentos : "");
      this.examForm.controls.peso.setValue(this.examen.peso);
      this.examForm.controls.talla.setValue(this.examen.talla);
      this.examForm.controls.indiceMasaCorporal.setValue(this.examen.indiceMasaCorporal);
      this.examForm.controls.frecuenciaPulso.setValue(this.examen.frecuenciaPulso);
      this.examForm.controls.presionSistolica.setValue(this.examen.presionSistolica);
      this.examForm.controls.presionDiastolica.setValue(this.examen.presionDiastolica);
      this.examForm.controls.noFumador.setValue(this.examen.noFumador);
      this.examen.exFumador ? this.examForm.controls.fumaUnoDiez.setValue(this.examen.exFumadorUnoDiez) :
        this.examForm.controls.fumaUnoDiez.setValue(this.examen.fumaUnoDiez);
      this.examen.exFumador ? this.examForm.controls.fumaOnceVeinte.setValue(this.examen.exFumadorOnceVeinte) :
        this.examForm.controls.fumaOnceVeinte.setValue(this.examen.fumaOnceVeinte);
      this.examen.exFumador ? this.examForm.controls.fumaMasVeinte.setValue(this.examen.exFumadorMasVeinte) :
        this.examForm.controls.fumaMasVeinte.setValue(this.examen.fumaMasVeinte);
      this.examForm.controls.cantidadFuma.setValue(this.examen.cantidadFuma);
      this.examForm.controls.unidadTiempo.setValue(this.examen.unidadTiempo);
      this.examForm.controls.consumeAlcohol.setValue(this.examen.consumeAlcohol);
      this.examForm.controls.cantidadAlcohol.setValue(this.examen.cantidadAlcohol);
      this.examForm.controls.tipoAlcohol.setValue(this.examen.tipoAlcohol);

      this.examForm.controls.pielAlteraciones.setValue(this.examen.pielAlteraciones);
      this.examForm.controls.ojosAlteraciones.setValue(this.examen.ojosAlteraciones);
      this.examForm.controls.cavidadOralAlteraciones.setValue(this.examen.cavidadOralAlteraciones);
      this.examForm.controls.narizAlteraciones.setValue(this.examen.narizAlteraciones);
      this.examForm.controls.rinoscopiaAlteraciones.setValue(this.examen.rinoscopiaAlteraciones);
      this.examForm.controls.cuelloAlteraciones.setValue(this.examen.cuelloAlteraciones);
      this.examForm.controls.toraxAlteraciones.setValue(this.examen.toraxAlteraciones);
      this.examForm.controls.cardiocirculatorioAlteraciones.setValue(this.examen.cardiocirculatorioAlteraciones);
      this.examForm.controls.abdomenAlteraciones.setValue(this.examen.abdomenAlteraciones);
      this.examForm.controls.columnaVertebralAlteraciones.setValue(this.examen.columnaVertebralAlteraciones);
      this.examForm.controls.osteoarticularAlteraciones.setValue(this.examen.osteoarticularAlteraciones);
      this.examForm.controls.examenNeurologicoAlteraciones.setValue(this.examen.examenNeurologicoAlteraciones);

      //this.examForm.controls.pielDescripcion?.setValue(this.examen.pielDescripcion ? this.examen.pielDescripcion : "");
      //this.examForm.controls.pielLocalizacion.setValue(this.examen.pielLocalizacion);
      this.examForm.controls.observacionesPiel?.setValue(this.examen.observacionesPiel ? this.examen.observacionesPiel : "");
      this.examForm.controls.descripcionOjos?.setValue(this.examen.descripcionOjos ? this.examen.descripcionOjos : "");
      this.examForm.controls.ojoIzquierdoSinCorreccion?.setValue(this.examen.ojoIzquierdoSinCorreccion || this.examen.ojoIzquierdoSinCorreccion === 0 ? this.examen.ojoIzquierdoSinCorreccion : null);
      this.examForm.controls.ojoIzquierdoConCorreccion?.setValue(this.examen.ojoIzquierdoConCorreccion || this.examen.ojoIzquierdoConCorreccion === 0 ? this.examen.ojoIzquierdoConCorreccion : null);
      this.examForm.controls.ojoDerechoSinCorreccion?.setValue(this.examen.ojoDerechoSinCorreccion || this.examen.ojoDerechoSinCorreccion === 0 ? this.examen.ojoDerechoSinCorreccion : null);
      this.examForm.controls.ojoDerechoConCorreccion?.setValue(this.examen.ojoDerechoConCorreccion || this.examen.ojoDerechoConCorreccion === 0 ? this.examen.ojoDerechoConCorreccion : null);
      this.examForm.controls.observacionOjos?.setValue(this.examen.observacionOjos ? this.examen.observacionOjos : "");
      this.examForm.controls.descripcionCavidadOral?.setValue(this.examen.descripcionCavidadOral ? this.examen.descripcionCavidadOral : "");
      this.examForm.controls.observacionesCavidadOral?.setValue(this.examen.observacionesCavidadOral ? this.examen.observacionesCavidadOral : "");
      this.examForm.controls.observacionesNariz?.setValue(this.examen.observacionesNariz ? this.examen.observacionesNariz : "");
      this.examForm.controls.observacionesRinoscopia?.setValue(this.examen.observacionesRinoscopia ? this.examen.observacionesRinoscopia : "");
      this.examForm.controls.observacionesCuelloAlteraciones?.setValue(this.examen.observacionesCuelloAlteraciones ?
        this.examen.observacionesCuelloAlteraciones : "");
      this.examForm.controls.observacionesCuello?.setValue(this.examen.observacionesCuello ? this.examen.observacionesCuello : "");
      this.examForm.controls.frecuenciaRespiratoria.setValue(this.examen.frecuenciaRespiratoria);
      this.examForm.controls.observacionesTorax?.setValue(this.examen.observacionesTorax ? this.examen.observacionesTorax : "");
      this.examForm.controls.descripcionRealizaTratHemorroides?.setValue(this.examen.descripcionRealizaTratHemorroides ?
        this.examen.descripcionRealizaTratHemorroides : "");
      this.examForm.controls.observacionesCardiocirculatorio?.setValue(this.examen.observacionesCardiocirculatorio ?
        this.examen.observacionesCardiocirculatorio : "");
      this.examen.varices && this.examen.modoVista !== 'ver' ? this.seccionVarices(true) : null;
      this.examForm.controls.hemorroides.setValue(this.examen.hemorroides);
      this.examen.hemorroides && this.examen.modoVista !== 'ver' ? this.clickRadioButton("SI", "HEMORROIDES") : null;
      this.examForm.controls.realizaTratHemorroides.setValue(this.examen.realizaTratHemorroides);
      this.examForm.controls.descripcionAbdomen?.setValue(this.examen.descripcionAbdomen ? this.examen.descripcionAbdomen : "");
      this.examForm.controls.observacionesAbdomen?.setValue(this.examen.observacionesAbdomen ? this.examen.observacionesAbdomen : "");
      this.examen.hernia && this.examen.modoVista !== 'ver' ? this.seccionHernia(true) : null;
      this.examForm.controls.umbilical.setValue(this.examen.umbilical);
      this.examForm.controls.dolorMolestiaRegionInguinal.setValue(this.examen.dolorMolestiaRegionInguinal);
      this.examForm.controls.herniaIncipiente.setValue(this.examen.herniaIncipiente);
      this.examForm.controls.anilloHerniarioComplaciente.setValue(this.examen.anilloHerniarioComplaciente);
      this.examForm.controls.observacionesColumnaVertebral?.setValue(this.examen.observacionesColumnaVertebral ? this.examen.observacionesColumnaVertebral : "");
      this.examForm.controls.observacionesOsteoarticular?.setValue(this.examen.observacionesOsteoarticular ? this.examen.observacionesOsteoarticular : "");
      this.examForm.controls.observacionesNeurologico?.setValue(this.examen.observacionesNeurologico ? this.examen.observacionesNeurologico : "");

      /*********************
       * * Habilitación de campos
       *********************/
      if(this.examen.modoVista !== 'ver') {
        this.examen.realizacionExamenPreocupacional ? this.habilitarCampo(true, "examenPreocupacionalObservacion") : null;
        this.examen.sintomasActividadLaboral ? this.habilitarCampo(true, "descripcionSintomasActividadLaboral") : null;
        this.examen.antecedentesPersonalesEnfermedades ? this.clickRadioButton("SI", "ANTECEDENTES") : null;
        this.examen.tomaMedicamentos ? this.habilitarCampo(true, "detalleTomaMedicamentos") : null;
        this.examen.exFumador || this.examen.noFumador === false ? this.seccionTabaquismo(true) : null;
        this.examen.consumeAlcohol ? this.seccionAlcohol("SI") : null;
        this.examen.pielAlteraciones ? this.seccionPiel("SI") : null;
        this.examen.ojosAlteraciones ? this.seccionOjos("SI") : null;
        this.examen.cavidadOralAlteraciones ? this.seccionCavidadOral("SI") : null;
        this.examen.narizAlteraciones ? this.habilitarCampo(true, "observacionesNariz") : null;
        this.examen.rinoscopiaAlteraciones ? this.seccionRinoscopia("SI") : null;
        this.examen.cuelloAlteraciones ? this.habilitarCampo(true, "observacionesCuelloAlteraciones") : null;
        this.examen.toraxAlteraciones ? this.seccionTorax("SI") : null;
        this.examen.cardiocirculatorioAlteraciones ? this.seccionCardiocirculatorio("SI") : null;
        this.examen.abdomenAlteraciones ? this.seccionAbdomen("SI") : null;
        this.examen.columnaVertebralAlteraciones ? this.seccionColumna("SI") : null;
        this.examen.osteoarticularAlteraciones ? this.seccionOsteoarticular("SI") : null;
        this.examen.examenNeurologicoAlteraciones ? this.seccionNeurologico("SI") : null;
        /* if(this.examen.otrosPielAlteraciones) {
          this.habilitarCampo(true, "pielDescripcion");
          this.examForm.controls.pielLocalizacion.enable();
          this.examForm.controls.pielLocalizacion.setValidators([
            Validators.required,
            Validators.maxLength(25),
          ]);
        } */
        this.examen.otrosOjos ? this.habilitarCampo(true, "descripcionOjos") : null;
        this.examen.otrosCavidadOral ? this.habilitarCampo(true, "descripcionCavidadOral") : null;
        this.examen.realizaTratHemorroides ? this.habilitarCampo(true, "descripcionRealizaTratHemorroides") : null;
        this.examen.otrasAbdomen ? this.habilitarCampo(true, "descripcionAbdomen") : null;
      }
    }
  }

  showModalFirma(){
		this.displayModalFirma = true;
	}

	closeModalFirma(){
		this.displayModalFirma = false;
	}

	recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
		this.medicoFirmaB64 = datos.firmaB64;
		this.medicoFirmaSigString = datos.firmaSigString;
	}

  deshabilitarApellidoNombreTrabajador() {
    return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
  }

  validateSeccionOjos():void{
    if(this.examForm.controls.ojoDerechoConCorreccion.value === null && this.examForm.controls.ojoDerechoSinCorreccion.value === null){
      this.examForm.controls.ojoDerechoSinCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
      this.examForm.controls.ojoDerechoConCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoIzquierdoConCorreccion.value === null && this.examForm.controls.ojoIzquierdoSinCorreccion.value === null){
      this.examForm.controls.ojoIzquierdoSinCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
      this.examForm.controls.ojoIzquierdoConCorreccion.setValidators([Validators.required,Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoDerechoConCorreccion.value || this.examForm.controls.ojoDerechoConCorreccion.value === 0){
      this.examForm.controls.ojoDerechoSinCorreccion.clearValidators();
      this.examForm.controls.ojoDerechoSinCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoDerechoSinCorreccion.value || this.examForm.controls.ojoDerechoSinCorreccion.value === 0){
      this.examForm.controls.ojoDerechoConCorreccion.clearValidators();
      this.examForm.controls.ojoDerechoConCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoIzquierdoConCorreccion.value || this.examForm.controls.ojoIzquierdoConCorreccion.value === 0){
      this.examForm.controls.ojoIzquierdoSinCorreccion.clearValidators();
      this.examForm.controls.ojoIzquierdoSinCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    if(this.examForm.controls.ojoIzquierdoSinCorreccion.value || this.examForm.controls.ojoIzquierdoSinCorreccion.value === 0){
      this.examForm.controls.ojoIzquierdoConCorreccion.clearValidators();
      this.examForm.controls.ojoIzquierdoConCorreccion.setValidators([Validators.min( 0 ), Validators.max( 10 )]);
    }

    this.examForm.controls.ojoDerechoSinCorreccion.updateValueAndValidity();
    this.examForm.controls.ojoDerechoConCorreccion.updateValueAndValidity();
    this.examForm.controls.ojoIzquierdoSinCorreccion.updateValueAndValidity();
    this.examForm.controls.ojoIzquierdoConCorreccion.updateValueAndValidity();
  }

}
